<template>
  <v-container id="inspire">
    <div class="container-inner">
      <PageTitle title="Edit Folder" />
      <div class="home-content">
        <v-form
          class="create-folder--form"
          ref="form"
          v-model="valid"
          @keydown.native.enter='validate'
          lazy-validation
        >
          <v-row>
            <v-col sm="12" md="6" lg="6" cols="12">
              <div class="header-content">Info</div>
              <v-row>
                <v-col cols="12">
                  <span class="label-text">Folder Name *</span>
                  <div class="input-mb input-box">
                    <v-text-field
                      tabindex="1"
                      @blur="isValidatedNameMethod"
                      dense
                      placeholder="Enter folder name"
                      v-model="folderToSubmit.name"
                      class="r-field folder-name-field"
                      :rules="nameRules"
                      required
                      maxlength="128"
                      :append-outer-icon="
                        nameErrCnt == 0 ? '' : isValidatedName ? 'mdi-checkbox-marked-circle' : 'mdi-alert-circle'
                      "
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <span class="label-text">Notes</span>
                  <div class="input-mb input-box">
                    <v-textarea
                      tabindex="1"
                      name="input-7-4"
                      label="Enter folder description"
                      hide-details="true"
                      single-line
                      dense
                      rows="5"
                      maxlength="255"
                      v-model="folderToSubmit.notes"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" />
            <v-col sm="12" md="5" lg="4" cols="12">
              <div class="header-content">Photo</div>
              <div class="upload_photo">
                <div id="my-strictly-unique-vue-upload-multiple-image">
                  <vue-upload-multiple-image
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    @edit-image="editImage"
                    @data-change="dataChange"
                    v-bind:dataImages="folderToSubmit.images"
                    :multiple-flag="false"
                    :maxImage="1"
                    v-model="folderToSubmit.images"
                  />
                </div>
                <div class="errorMessage" v-if="uploadingFailed">
                  Error image uploading, try another image
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="text-left pt-10">
                <v-btn
                  @click.stop="cancel"
                  depressed
                  class="cancel-btn"
                >
                  Cancel
                </v-btn>
                <v-btn
                  tabindex="1"
                  @click="validate"
                  depressed
                  :disabled="!valid"
                  class="edit-folder-btn save-btn"
                >
                  Save
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>
    <UnsavedChangesPopup />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VueUploadMultipleImage from '@/components/upload-image/VueUploadMultipleImage'
import UnsavedChangesPopup from '@/components/popup/UnsavedChangesPopup'
import PageTitle from '@/components/page/PageTitle'
import service from '@/services/inventory'
import {
  MODULE_POPUP,
  SET_UNSAVED_CHANGES_POPUP_SHOW,
  MODULE_FORM,
  SET_FORM_DATA_ORIGIN,
  SET_FORM_DATA_NEW,
  SET_NEED_CHECK_FORM_OFF
} from '@/store/constant/mutation-types'

export default {
  name: 'Home',
  components: {
    VueUploadMultipleImage,
    UnsavedChangesPopup,
    PageTitle
  },
  data() {
    return {
      changedFlag: false,
      changedCount: 0,
      valid: true,
      params: [
        {
          foo: 0,
          placeholder: '',
          type: 0
        },
        {
          foo: '',
          placeholder: 'Enter Min Level',
          type: 1
        }
      ],
      folderToSubmit: {
        name: '',
        locationCode: '',
        notes: '',
        images: [],
        parentId: null
      },
      chips: [],
      select: ['add-tags-with', 'enter', 'tab', 'paste'],
      folders: [],
      confirmDialog: false,
      nameErrCnt: 0,
      nameRules: [(value) => !!value || 'Please enter name'],
      category: {},
      categoryId: 1,
      tmpCategoryId: '',
      curUserInventoryId: '',
      imageFormData: '',
      uploadingFailed: false,
      tmpCategories: [],
      showCreateLabelForm: false
    }
  },
  computed: {
    ...mapGetters('inventory', ['categories', 'categoryById']),
    ...mapGetters('warehouses', ['getActiveWarehouse']),
    isValidatedName() {
      const validRegEx = /\S+/
      return (
        this.folderToSubmit.name !== null &&
        validRegEx.test(this.folderToSubmit.name)
      )
    }
  },
  watch: {
    getActiveWarehouse() {
      this.$router.push({ name: 'Inventory' })
    },
    isValidatedName: {
      deep: true,
      handler: function (newVal) {
        this.nameErrCnt++
      }
    },
    folderToSubmit: {
      deep: true,
      handler: function (val, newVal) {
        this.$store.commit(
          `${MODULE_FORM}/${SET_FORM_DATA_NEW}`,
          this.folderToSubmit
        )
      }
    }
  },
  mounted() {},
  async created() {
    if (!this.getActiveWarehouse) this.$router.replace({ name: 'Inventory' })
    if (+this.$route.params.id) {
      const response = await service.getCategory({ id: +this.$route.params.id })
      const res = response.data.data
      if (response?.data?.error?.type === 200) {
        this.category = res
        this.tmpCategoryId = res.id
        this.folderToSubmit.name = res.name
        this.folderToSubmit.notes = res.description
        this.folderToSubmit.parentId = res.parentId

        const formData = new FormData()
        formData.append('file', res.image)
        if (res.image == null) {
          this.folderToSubmit.images = []
        } else {
          this.folderToSubmit.images.splice(0, 1, {
            path: res.image,
            highlight: 1
          })
        }
        this.curUserInventoryId = this.getCategories.id
      }
    }
    this.$store.commit(
      `${MODULE_FORM}/${SET_FORM_DATA_ORIGIN}`,
      this.folderToSubmit
    )
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.$store.getters[`${MODULE_FORM}/isNeedCheckForm`] &&
      this.$store.getters[`${MODULE_FORM}/isFormDataChanged`]
    ) {
      this.$store.commit(
        `${MODULE_POPUP}/${SET_UNSAVED_CHANGES_POPUP_SHOW}`,
        true
      )
      next(false)
    } else {
      next()
    }
  },
  methods: {
    ...mapActions('inventory', [
      'editFolder',
      'getCategory',
      'getCategories',
      'uploadImage',
      'deleteImage'
    ]),
    uploadImageSuccess(formData, index, fileList) {
      this.imageFormData = formData
      this.uploadingFailed = false
      this.changedFlag = true
    },
    beforeRemove(index, done, fileList) {
      this.folderToSubmit.images[0] = null
      this.imageFormData = ''
      this.changedFlag = true
    },
    editImage(formData, index, fileList) {},
    dataChange(data) {},
    async validate() {
      if (!this.$refs.form.validate()) {
        return
      }

      let image
      if (
        Array.isArray(this.folderToSubmit.images) &&
        this.folderToSubmit.images[0]
      ) {
        image = this.folderToSubmit.images[0].path
      }

      if (this.imageFormData) {
        await this.uploadImage(this.imageFormData).then((res) => {
          if (res !== 'Uploading failed') {
            image = res[0]
          }
        })
      }

      const payload = {
        id: this.tmpCategoryId,
        inventoryId: this.getActiveWarehouse.id,
        name: this.folderToSubmit.name,
        parentId: this.folderToSubmit.parentId,
        description: this.folderToSubmit.notes
      }
      if (image) {
        payload.image = image
      }

      this.$store.commit(`${MODULE_FORM}/${SET_NEED_CHECK_FORM_OFF}`)
      await this.editFolder(payload)
    },
    setQuantity(event) {
      this.folderToSubmit.quantity = event
    },
    cancel() {
      this.$router.push('/inventory')
    },
    isValidatedNameMethod() {
      const validRegEx = /\S+/
      if (
        this.folderToSubmit.name === '' &&
        !validRegEx.test(this.folderToSubmit.name)
      ) {
        this.nameErrCnt = 1
      }
    }
  }
}
</script>

<style lang="scss">
#inspire {
  ::v-deep .v-messages__message {
    color: #ff5252;
    font-size: 13px;
    text-align: left;
    line-height: 1.3;
    padding: 3px 0;
  }

  ::v-deep .image-list-container {
    display: none;
  }

  .v-text-field--outlined {
    border-color: rgba(192, 0, 250, 0.986);
  }

  .v-messages,
  .v-text-field__details {
    min-height: 0 !important;
  }

  .v-text-field__details {
    padding: 0 4px !important;
  }

  .create-folder--form {
    max-width: 1400px;
    padding-bottom: 60px;
  }
}
</style>

<style scoped lang="scss">
::v-deep .v-textarea {
  textarea {
    overflow: hidden !important;
  }

  .v-label {
    padding: 8px 18px;
    line-height: 30px;
    height: auto;
  }
}

::v-deep .container {
  width: 100%;
  padding: 0 !important;
  margin-right: auto;
}
</style>
